import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/Styles.css'
import './css/Responsive.css'
import './css/Components.css'
import App from './App';
import reportWebVitals from './reportWebVitals';

// Default UI scale — renders the whole app as if the browser were zoomed to 90%.
// Full-screen heights use var(--app-height) instead of 100vh: under CSS zoom,
// browsers disagree on whether vh is scaled, but px always is, so the real
// window height divided by the zoom always fills the screen exactly.
const APP_ZOOM = 0.9;
document.documentElement.style.zoom = APP_ZOOM;
const setAppHeight = () =>
  document.documentElement.style.setProperty('--app-height', `${window.innerHeight / APP_ZOOM}px`);
setAppHeight();
window.addEventListener('resize', setAppHeight);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
